import { ResponsiveImage } from 'approot/shared/images/imgix-responsive.constants';
import { useSlideBackground } from '../styles/styles-drawer.hooks';
import { PresentationBackground } from './activity-present-background.style';
import type { GetPublishedLessonActivitiesByVersionQuery } from '../graphql/get-published-lesson-activities-by-version.graphql.generated';
import type { Pluck } from 'lib/gql/pluck';

type Props = {
  backgroundVisibility: boolean;
  showIntroduction: boolean;
  styles?: Pluck<
    GetPublishedLessonActivitiesByVersionQuery,
    'getPublishedLessonActivitiesByVersion.styles'
  > | null;
  responsiveImage?: ResponsiveImage[] | null;
};

const ActivityPresentBackground = ({
  backgroundVisibility,
  showIntroduction,
  styles,
  responsiveImage,
}: Props) => {
  const { backgroundColour, backgroundImage } = useSlideBackground(
    styles ? styles.defaultBackgroundStyle : undefined,
    responsiveImage
  );

  return (
    <PresentationBackground
      $backgroundColour={
        showIntroduction
          ? backgroundColour
          : backgroundVisibility
            ? backgroundColour
            : undefined
      }
      $backgroundImage={
        showIntroduction
          ? backgroundImage
          : backgroundVisibility
            ? backgroundImage
            : undefined
      }
    />
  );
};

export default ActivityPresentBackground;
